import { render, staticRenderFns } from "./fixAdminPW.vue?vue&type=template&id=37d3fb15"
import script from "./fixAdminPW.vue?vue&type=script&lang=js"
export * from "./fixAdminPW.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports